import React, { useState, useCallback, useRef, useEffect, useMemo } from 'react';
import { 
  Card, 
  Descriptions, 
  Tag, 
  Progress, 
  Button, 
  Space, 
  Table,
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  InputNumber,
  Typography,
  Row,
  Col,
  Statistic,
  Spin,
  message,
  List,
  Switch,
  AutoComplete,
  Checkbox
} from 'antd';
import { 
  ProjectOutlined, 
  PlusOutlined, 
  EditOutlined,
  DeleteOutlined,
  ArrowLeftOutlined,
  FileTextOutlined,
  BarChartOutlined,
  UnorderedListOutlined
} from '@ant-design/icons';
import { Gantt, ViewMode } from 'gantt-task-react';
import 'gantt-task-react/dist/index.css';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import dayjs from 'dayjs';
import { useAuthStore } from '../../stores/authStore';
import { calculateEndDateByHours, getCurrentWorkday, countWorkdaysInclusive } from '../../utils/workdayUtils';

const { TextArea } = Input;
const { Option } = Select;
const { Text } = Typography;

const DEFAULT_TASK_TITLES = ['重亮点清单','平面布局图','效果图','彩立面','画册文字','画册制作','施工图','视频解说词','预算'];
const DEFAULT_TASK_TITLE_OPTIONS = DEFAULT_TASK_TITLES.map(t => ({ value: t, label: t }));

const ProjectDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { user } = useAuthStore();
  
  const [isTaskModalVisible, setIsTaskModalVisible] = useState(false);
  const [editingTask, setEditingTask] = useState(null);
  const [taskForm] = Form.useForm();
  const [isTemplateModalVisible, setIsTemplateModalVisible] = useState(false);
  const [templateStartDate, setTemplateStartDate] = useState(dayjs());
  const [viewMode, setViewMode] = useState('gantt'); // 榛樿杩涘叆鐢樼壒鍥炬ā寮忥紙'gantt' 鎴?'list'锛?
const [isUpdatingTask, setIsUpdatingTask] = useState(false); // 鐢樼壒鍥句换鍔℃洿鏂板姞杞界姸鎬?
const [taskTitleOptions, setTaskTitleOptions] = useState(DEFAULT_TASK_TITLE_OPTIONS); // 任务标题下拉选项（含默认建议）
// 负责人项目弹窗可见性
const [isLeaderProjectsModalVisible, setIsLeaderProjectsModalVisible] = useState(false);

  // 鐢ㄤ簬琛ㄦ牸鍐呰仈缂栬緫鎵ц浜虹殑鐘舵€?
  const [editingAssigneeTaskId, setEditingAssigneeTaskId] = useState(null);
  
  // 鎵归噺閫夋嫨浠诲姟鐨勯€変腑闆嗗悎锛堝瓨鍌ㄤ换鍔D锛?
  const [selectedTaskIds, setSelectedTaskIds] = useState([]);
  // 鎵归噺鍒犻櫎鐨勫姞杞界姸鎬?
  const [isBatchDeleting, setIsBatchDeleting] = useState(false);

  // 鑾峰彇椤圭洰璇︽儏锛堝繀椤诲湪浠讳綍浣跨敤 projectData 鐨?Hook 涔嬪墠澹版槑锛岄伩鍏?TDZ 杩愯鏃堕敊璇級
  // 璇存槑锛氭鍓嶅湪涓嬫柟 useEffect 涓娇鐢ㄤ簡 projectData锛岃嫢鍦ㄥ叾鍚庡啀澹版槑浼氳Е鍙?
  // ReferenceError: Cannot access 'projectData' before initialization
  const { data: projectData, isLoading } = useQuery(
    ['project', id],
    () => axios.get(`/projects/${id}`).then(res => res.data.data),
    { refetchInterval: 30000 }
  );

  /**
   * 鍒囨崲閫変腑鏌愪釜浠诲姟
   * 璇存槑锛氫緵鐢樼壒鍥捐嚜瀹氫箟浠诲姟娓呭崟鍜岃〃鏍艰鍥惧叡鍚岃皟鐢?
   */
  const toggleSelectTask = useCallback((taskId) => {
    setSelectedTaskIds((prev) => {
      const set = new Set(prev);
      if (set.has(taskId)) set.delete(taskId); else set.add(taskId);
      return Array.from(set);
    });
  }, []);

  /**
   * 涓枃鍑芥暟绾ф敞閲婏細鍒囨崲鈥滃叏閫?鍙栨秷鍏ㄩ€夆€濅换鍔?
   * 璇存槑锛氱偣鍑荤敇鐗瑰浘浠诲姟娓呭崟琛ㄥご涓殑鈥滈€夋嫨鈥濇枃瀛楁椂璋冪敤锛?
   * - 鑻ュ綋鍓嶅苟闈炲叏閮ㄩ€変腑锛屽垯灏嗘墍鏈変换鍔D鍔犲叆閫変腑闆嗗悎锛?
   * - 鑻ュ綋鍓嶅凡鍏ㄩ儴閫変腑锛屽垯娓呯┖閫変腑闆嗗悎銆?
   */
  const toggleSelectAllTasks = useCallback(() => {
    const allTaskIds = projectData?.project?.tasks?.map(t => t.id) || [];
    if (allTaskIds.length === 0) return;
    const allSelected = allTaskIds.every(id => selectedTaskIds.includes(id));
    setSelectedTaskIds(allSelected ? [] : allTaskIds);
  }, [projectData, selectedTaskIds]);

  /**
   * 褰撻」鐩垨浠诲姟鍒楄〃鍙樺寲鏃讹紝娓呯悊宸蹭笉瀛樺湪鐨勯€変腑浠诲姟锛屼繚鎸侀€変腑鐘舵€佷笌鏈€鏂版暟鎹竴鑷?
   */
  useEffect(() => {
    const ids = projectData?.project?.tasks?.map(t => t.id) || [];
    setSelectedTaskIds(prev => prev.filter(id => ids.includes(id)));
  }, [projectData]);

  /**
   * 鎵归噺鍒犻櫎宸查€変换鍔?
   * 鏉冮檺瑙勫垯锛氫笌鍗曟潯鍒犻櫎涓€鑷达紙鍒涘缓鑰呫€佽璁¤礋璐ｄ汉銆乵anager銆乤dmin锛夛紝鏃犳潈闄愮殑浠诲姟浼氳鑷姩璺宠繃骞舵彁绀烘暟閲?
   */
  const handleBatchDeleteSelected = useCallback(() => {
    const tasks = projectData?.project?.tasks || [];
    const selectedTasks = tasks.filter(t => selectedTaskIds.includes(t.id));
    if (selectedTasks.length === 0) {
      message.warning('请先选择要删除的任务');
      return;
    }
    const deletable = selectedTasks.filter(t => (
      t.createdBy === user?.id || projectData?.project?.designLeaderId === user?.id || ['manager','admin'].includes(user?.role)
    ));
    const nonDeletableCount = selectedTasks.length - deletable.length;

    Modal.confirm({
      title: '批量删除确认',
      content: (
        nonDeletableCount > 0
          ? `共选择 ${selectedTasks.length} 个任务，其中 ${nonDeletableCount} 个无权限删除，将被跳过。是否继续删除其余 ${deletable.length} 个任务？`
          : `确定要删除已选择的 ${deletable.length} 个任务吗？此操作不可撤销。`
      ),
      okText: '删除',
      cancelText: '取消',
      okType: 'danger',
      onOk: async () => {
        if (deletable.length === 0) return;
        try {
          setIsBatchDeleting(true);
          const hide = message.loading('正在批量删除所选任务...', 0);
          const results = await Promise.allSettled(
            deletable.map(t => axios.delete(`/tasks/${t.id}`))
          );
          hide();
          const successCount = results.filter(r => r.status === 'fulfilled').length;
          const failCount = results.length - successCount;
          if (successCount > 0) {
            message.success(`成功删除 ${successCount} 个任务${failCount > 0 ? `，失败 ${failCount} 个` : ''}`);
          }
          if (failCount > 0) {
            message.error('部分任务删除失败，请稍后重试');
          }
          setSelectedTaskIds([]);
          queryClient.invalidateQueries(['project', id]);
        } catch (e) {
          message.error('批量删除失败');
        } finally {
          setIsBatchDeleting(false);
        }
      }
    });
  }, [projectData, selectedTaskIds, user, queryClient, id]);

  // 鏍规嵁鑱屼綅瀵圭敤鎴疯繘琛屽垎缁勯€昏緫灏嗘斁鍦?usersData 鑾峰彇涔嬪悗锛岄伩鍏嶅湪澹版槑鍓嶄娇鐢?
  // 瑙佷笅鏂光€滆幏鍙栫敤鎴峰垪琛ㄢ€濅箣鍚庣殑 useMemo 瀹氫箟
  
  /**
   * 鐐瑰嚮鈥滄墽琛屼汉鈥濆崟鍏冩牸锛岃繘鍏ュ彲缂栬緫鐘舵€?
   */
  const handleAssigneeCellClick = (record) => {
    if (!['admin','manager','pm','designer'].includes(user?.role)) return;
    setEditingAssigneeTaskId(record.id);
  };

  /**
   * 鎵ц浜洪€夋嫨鍙樻洿鍚庯紝璋冪敤浠诲姟鏇存柊鎺ュ彛
   */
  const handleAssigneeChange = (taskId, assigneeId) => {
    updateTaskMutation.mutate({ taskId, updateData: { assignedTo: assigneeId } });
    setEditingAssigneeTaskId(null);
  };

  /**
   * 閫夋嫨鍣ㄥけ鐒︽椂閫€鍑虹紪杈?
   */
  const handleAssigneeBlur = () => {
    setEditingAssigneeTaskId(null);
  };

  // 鑾峰彇椤圭洰璇︽儏
  // const { data: projectData, isLoading } = useQuery(
  //   ['project', id],
  //   () => axios.get(`/projects/${id}`).then(res => res.data.data),
  //   { refetchInterval: 30000 }
  // );

  // 鑾峰彇鐢ㄦ埛鍒楄〃锛堢粺涓€杩斿洖鏁扮粍锛屽吋瀹圭紦瀛橀噷鍙兘瀛樺湪鐨勫璞″舰鎬侊級
  const { data: usersData } = useQuery(
    ['users', 'flat'],
     () => axios.get('/auth/users', {
       // 用户接口默认只返回 50 条；执行人下拉框需要加载全部可选用户
       params: { page: 1, limit: 1000 }
     }).then(res => res.data?.data?.users || [])
  );

  // 涓枃璇存槑锛氬皢鐢ㄦ埛鏁版嵁瑙勮寖鍖栦负鏁扮粍锛屽吋瀹逛袱绉嶈繑鍥炲舰鎬侊紙鏁扮粍鎴?{ users, pagination }锛夛紝閬垮厤鍥犵紦瀛樺鑷寸殑鏂规硶璋冪敤閿欒
  const usersArray = useMemo(() => {
  if (Array.isArray(usersData)) return usersData;
  if (usersData && Array.isArray(usersData.users)) return usersData.users;
  return [];
  }, [usersData]);

   /**
    * 鏍规嵁鑱屼綅瀵圭敤鎴疯繘琛屽垎缁勶紝渚涙墽琛屼汉涓嬫媺閫夋嫨浣跨敤
    * 浠呭寘鍚鑹蹭负 designer / manager / pm 鐨勭敤鎴?
    */
   const groupedUsersByPosition = useMemo(() => {
     if (!usersArray || usersArray.length === 0) return {};
     const eligible = usersArray.filter(u => ['designer','manager','pm'].includes(u.role));
     return eligible.reduce((acc, u) => {
       const pos = u.position || '未设置职位';
       if (!acc[pos]) acc[pos] = [];
       acc[pos].push(u);
       return acc;
     }, {});
   }, [usersArray]);

  // 鑾峰彇浠诲姟妯℃澘鍒楄〃
  const { data: templatesData } = useQuery(
    'templates',
    () => axios.get('/templates', { params: { status: 'active' } }).then(res => res.data.data)
  );

  // 鑾峰彇鏍囧噯娴佺▼妯℃澘鐨勪换鍔℃爣棰橀€夐」
  useEffect(() => {
    if (projectData?.project?.type && templatesData?.templates) {
      // 绛涢€夌浉鍚岄」鐩被鍨嬩笖鍚嶇О鍖呭惈"鏍囧噯娴佺▼"鐨勬ā鏉?
      const standardTemplates = templatesData.templates.filter(template => 
        template.projectType === projectData.project.type && 
        template.name.includes('鏍囧噯娴佺▼')
      );
      
      // 鎻愬彇鎵€鏈変换鍔℃爣棰?
      const titles = [];
      standardTemplates.forEach(template => {
        if (template.taskList && Array.isArray(template.taskList)) {
          template.taskList.forEach(task => {
            if (task.title && !titles.includes(task.title)) {
              titles.push(task.title);
            }
          });
        }
      });
      
      // 合并默认任务标题并去重
      const mergedTitles = Array.from(new Set([...DEFAULT_TASK_TITLES, ...titles]));
      const options = mergedTitles.map(title => ({ value: title, label: title }));
      setTaskTitleOptions(options);
    }
  }, [projectData?.project?.type, templatesData?.templates]);

  // 鍒涘缓/鏇存柊浠诲姟
  const taskMutation = useMutation(
    (taskData) => {
      if (editingTask) {
        return axios.put(`/tasks/${editingTask.id}`, taskData);
      } else {
        return axios.post('/tasks', { ...taskData, projectId: id });
      }
    },
    {
      onSuccess: () => {
        message.success(editingTask ? '任务更新成功' : '任务创建成功');
        setIsTaskModalVisible(false);
        setEditingTask(null);
        taskForm.resetFields();
        queryClient.invalidateQueries(['project', id]);
      },
      onError: (error) => {
        message.error(error.response?.data?.message || '操作失败');
      }
    }
  );

  // 鍒犻櫎浠诲姟澶勭悊鍑芥暟
  const handleDeleteTask = (task) => {
    // 妫€鏌ュ垹闄ゆ潈闄愶細鍒涘缓鑰呫€佽璁¤礋璐ｄ汉銆乵anager銆乤dmin
    const canDelete = task.createdBy === user?.id ||
                     project?.designLeaderId === user?.id ||
                     ['manager', 'admin'].includes(user?.role);
    
    if (!canDelete) {
      message.error('您没有权限删除此任务');
      return;
    }

    Modal.confirm({
      title: '确认删除',
      // 确认删除单个任务的二次确认弹窗
      content: `确定要删除任务“${task.title}”吗？此操作不可撤销。`,
      okText: '确定',
      cancelText: '取消',
      okType: 'danger',
      onOk: () => {
        deleteTaskMutation.mutate(task.id);
      }
    });
  };

  // 鍒犻櫎浠诲姟
  const deleteTaskMutation = useMutation(
    (taskId) => axios.delete(`/tasks/${taskId}`),
    {
      onSuccess: () => {
        message.success('任务删除成功');
        queryClient.invalidateQueries(['project', id]);
      },
      onError: (error) => {
        message.error(error.response?.data?.message || '删除失败');
      }
    }
  );

  // 鏇存柊浠诲姟鏃堕棿鍜岃繘搴︾殑 mutation
  const updateTaskMutation = useMutation(
    ({ taskId, updateData }) => axios.put(`/tasks/${taskId}`, updateData),
    {
      onMutate: () => {
        setIsUpdatingTask(true);
      },
      onSuccess: () => {
        message.success('任务更新成功');
        queryClient.invalidateQueries(['project', id]);
        queryClient.invalidateQueries('projects');
        queryClient.invalidateQueries('recentProjects');
        setIsUpdatingTask(false);
      },
      onError: (error) => {
        message.error(error.response?.data?.message || '更新失败');
        setIsUpdatingTask(false);
      }
    }
  );

  const project = projectData?.project;
// 根据设计负责人ID获取其负责的项目列表（弹窗打开时触发）
const designLeaderId = project?.designLeaderId || project?.designLeader?.id;
const { data: leaderProjectsData, isLoading: isLoadingLeaderProjects } = useQuery(
  ['leaderProjects', designLeaderId],
  () => axios.get('/projects', { params: { designLeaderId, limit: 200 } }).then(res => res.data?.data),
  { enabled: isLeaderProjectsModalVisible && !!designLeaderId }
);

  /**
   * 鏍煎紡鍖栫敇鐗瑰浘鏃堕棿杞寸殑鏃ユ湡鏂囨湰涓?M/D锛堝 3/15锛?
   * 娉ㄦ剰锛氬繀椤诲湪缁勪欢椤跺眰璋冪敤 useEffect锛屼笉鑳芥斁鍦?JSX 鍐呴儴锛屽惁鍒欎細瀵艰嚧缂栬瘧閿欒
   */
  /**
   * 涓枃鍑芥暟绾ф敞閲婏細灏嗙敇鐗瑰浘鏃ユ湡琛ㄥご浠庝竴琛屾敼涓轰袱琛岋紙涓婇潰鈥滃嚑鏃モ€濓紝涓嬮潰鈥滄槦鏈熷嚑鈥濓級
   * 瀹炵幇鏂瑰紡锛氬湪鐢樼壒鍥炬覆鏌撳畬鎴愬悗锛岄亶鍘嗘椂闂磋酱澶撮儴鍏冪礌锛?
   * - 瑙ｆ瀽姣忎釜鏃ユ湡鏂囨湰锛屾彁鍙栤€滄棩鈥?D) 涓?鈥滃懆鍑犫€濓紱
   * - 灏嗗叾鍐欏叆 data-day 鍜?data-weekday 鑷畾涔夊睘鎬э紱
   * - 娓呯┖鍘熸湰鐨勬枃鏈紝鐢?CSS 浼厓绱?::before/::after 杩涜涓よ灞曠ず銆?
   */
  // 中文函数级注释：将甘特图表头的“日期 + 星期”从一行拆成两行（上一行显示日期，下一行显示星期）
  // 实现思路：甘特图表头由 gantt-task-react 以 SVG text 渲染（顶部分组 + 底部文本），因此不能使用 ::before/::after 伪元素。
  // 我们在甘特图渲染后抓取 SVG 中的两个文本层（顶部与底部），按 x 坐标一一配对，然后把顶部文本替换为“日期”，底部文本替换为“星期”。
  useEffect(() => {
    if (viewMode !== 'gantt') return;
    if (!project?.tasks?.length) return;

    // 工具：将 JS Date 转换为中文星期
    const toWeekday = (date) => {
      // 使用中文数字表示星期，不带“周”前缀
      const d = dayjs(date);
      const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
      return weekdays[d.day()];
    };

    // 工具：解析“顶部文本”（通常是月份或年月）得到 {year, month}，用于组合完整日期
    const parseYearMonth = (rawTop) => {
      if (!rawTop) return { year: dayjs().year(), month: dayjs().month() + 1 };
      const text = rawTop.trim();
      // 支持格式示例："Mar", "Mar 2025", "September", "2025-03", "2025/03", "3月", "2025年3月", "九月", "2025年十月"
      const monthNames = {
        jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6,
        jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12
      };
      const monthNamesFull = {
        january: 1, february: 2, march: 3, april: 4, may: 5, june: 6,
        july: 7, august: 8, september: 9, october: 10, november: 11, december: 12
      };
      let year = dayjs().year();
      let month = dayjs().month() + 1;

      // 英文月份缩写 + 可选年份
      const enMatch = text.match(/^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)(?:\s+(\d{4}))?$/i);
      if (enMatch) {
        month = monthNames[enMatch[1].toLowerCase()];
        if (enMatch[2]) year = parseInt(enMatch[2], 10);
        return { year, month };
      }

      // 英文完整月份 + 可选年份
      const enFullMatch = text.match(/^(january|february|march|april|may|june|july|august|september|october|november|december)(?:\s+(\d{4}))?$/i);
      if (enFullMatch) {
        month = monthNamesFull[enFullMatch[1].toLowerCase()];
        if (enFullMatch[2]) year = parseInt(enFullMatch[2], 10);
        return { year, month };
      }

      // 年-月 或 年/月
      const ymMatch = text.match(/^(\d{4})[-\/]?(\d{1,2})$/);
      if (ymMatch) {
        year = parseInt(ymMatch[1], 10);
        month = parseInt(ymMatch[2], 10);
        return { year, month };
      }

      // 中文“2025年3月”或“3月”（数字）
      const zhYMonth = text.match(/^(?:(\d{4})年)?(\d{1,2})月$/);
      if (zhYMonth) {
        if (zhYMonth[1]) year = parseInt(zhYMonth[1], 10);
        month = parseInt(zhYMonth[2], 10);
        return { year, month };
      }

      // 中文大写数字月份：“九月”、“十月”、“十一月”、“十二月”，可带“2025年”
      const zhCnMonthMatch = text.match(/^(?:(\d{4})年)?((?:十[一二])|十|[一二三四五六七八九])月$/);
      if (zhCnMonthMatch) {
        if (zhCnMonthMatch[1]) year = parseInt(zhCnMonthMatch[1], 10);
        const zh = zhCnMonthMatch[2];
        const zhMap = { '一': 1, '二': 2, '三': 3, '四': 4, '五': 5, '六': 6, '七': 7, '八': 8, '九': 9, '十': 10, '十一': 11, '十二': 12 };
        month = zhMap[zh] || month;
        return { year, month };
      }

      // 兜底：使用当前年月
      return { year, month };
    };

    const transformHeader = () => {
      // 修正：gantt-task-react 的日历头部是 SVG 内部的 <g class="calendar">，不是 div
      // 因此需从 <g.calendar> 出发拿到所属的 <svg>，并在该分组内处理文本
      const calendarGroup = document.querySelector('g.calendar');
      const headerSvg = calendarGroup?.closest('svg');
      if (!calendarGroup || !headerSvg) return;

      // 优先读取日历头部 rect 的高度作为 headerHeight
      const headerRect = calendarGroup.querySelector('rect');
      const headerHeight = parseFloat(headerRect?.getAttribute('height') || '0') || 60;
      // 仅查询日历分组内部的文本节点，避免误选到其它图层的 text
      const texts = Array.from(calendarGroup.querySelectorAll('text'));
      if (texts.length === 0) return;

      // 按 y 坐标分层：顶部文本（y 比较小），底部文本（y 更靠近 headerHeight）
      const topTexts = [];
      const bottomTexts = [];
      texts.forEach((t) => {
        const y = parseFloat(t.getAttribute('y') || '0');
        if (y >= headerHeight * 0.6) bottomTexts.push(t); else topTexts.push(t);
      });
      // 若顶部文本为空，则补一个“YYYY/MM”居中显示；并继续处理底部两行
      if (bottomTexts.length === 0) return;
      if (topTexts.length === 0) {
        const existingTopFixed = calendarGroup.querySelector('text[data-top-fixed="1"]');
        if (!existingTopFixed) {
          const rectWidth = parseFloat(headerRect?.getAttribute('width') || '0');
          const centerX = rectWidth ? rectWidth / 2 : parseFloat(bottomTexts[0].getAttribute('x') || '0');
          const topY = Math.round(headerHeight * 0.35);
          const now = dayjs();
          const yyyymm = `${now.year()}/${now.month() + 1}`;
          const topTextEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
          topTextEl.setAttribute('x', String(centerX));
          topTextEl.setAttribute('y', String(topY));
          topTextEl.setAttribute('text-anchor', 'middle');
          topTextEl.setAttribute('data-top-fixed', '1');
          topTextEl.textContent = yyyymm;
          calendarGroup.appendChild(topTextEl);
        }
      }

      // 建立按 x 坐标的最近配对关系
      const toPairs = () => {
        const pairs = [];
        bottomTexts.forEach((bt) => {
          const bx = parseFloat(bt.getAttribute('x') || '0');
          let minDx = Infinity;
          let closestTop = null;
          topTexts.forEach((tt) => {
            const tx = parseFloat(tt.getAttribute('x') || '0');
            const dx = Math.abs(tx - bx);
            if (dx < minDx) { minDx = dx; closestTop = tt; }
          });
          if (closestTop) pairs.push([closestTop, bt]);
        });
        return pairs;
      };

      const pairs = toPairs();
      if (pairs.length === 0) return;

      // 计算列宽与头部 y，用于周末底色定位
      const bottomXs = bottomTexts
        .map(bt => parseFloat(bt.getAttribute('x') || '0'))
        .filter(x => !isNaN(x))
        .sort((a, b) => a - b);
      let columnWidthPx = 0;
      for (let i = 1; i < bottomXs.length; i++) {
        const dx = bottomXs[i] - bottomXs[i - 1];
        if (dx > 0 && (columnWidthPx === 0 || dx < columnWidthPx)) {
          columnWidthPx = dx;
        }
      }
      if (columnWidthPx <= 0) columnWidthPx = 40; // 兜底
      const headerY = parseFloat(headerRect?.getAttribute('y') || '0') || 0;

      // 追踪跨列的当前年月与日，保证跨月显示正确
      const sortedPairs = pairs.slice().sort((a, b) => {
        const ax = parseFloat(a[1].getAttribute('x') || '0');
        const bx = parseFloat(b[1].getAttribute('x') || '0');
        return ax - bx;
      });
      const _initYM = parseYearMonth(topTexts[0]?.textContent || '');
      let trackYear = _initYM.year;
      let trackMonth = _initYM.month; // 1-12
      let prevDayNum = null;

      sortedPairs.forEach(([tt, bt]) => {
        const rawBottom = (bt.textContent || '').trim();

        // 已由按列推进的 trackYear/trackMonth 变量替代顶部年月解析
        // const { year, month } = parseYearMonth(rawTop);

        // 如果已经处理过（存在我们标记 data-split=1），跳过避免重复注入
        if (bt.getAttribute('data-split') === '1') return;

        // 解析底部文本并计算两行文案（第一行：MM/DD；第二行：周X）
        const parts = rawBottom.split(/\s+/).filter(Boolean);
        let dateText = '';
        let weekdayText = '';

        if (parts.length >= 2 && /周[一二三四五六日天]/.test(parts[parts.length - 1])) {
          const weekdayPart = parts.pop();
          const datePart = parts.join(' ');
          const mmddMatchInDate = datePart.match(/^(\d{1,2})\/(\d{1,2})$/);
          const dayMatchInDatePart = datePart.match(/\b(\d{1,2})\b/);
          if (mmddMatchInDate) {
            // 形式：MM/DD 周X —— 明确给出月份，更新追踪年月
            const m = parseInt(mmddMatchInDate[1], 10);
            const dnum = parseInt(mmddMatchInDate[2], 10);
            trackMonth = m;
            prevDayNum = dnum;
            dateText = `${m}/${dnum}`;
            const d = dayjs(`${trackYear}-${String(m).padStart(2, '0')}-${String(dnum).padStart(2, '0')}`);
            weekdayText = toWeekday(d);
          } else if (dayMatchInDatePart) {
            // 形式：DD 周X —— 只给日，使用追踪的月份；若跨月（当前日小于前一列日），月份+1
            const dnum = parseInt(dayMatchInDatePart[1], 10);
            if (prevDayNum !== null && dnum < prevDayNum) {
              trackMonth += 1;
              if (trackMonth > 12) { trackMonth = 1; trackYear += 1; }
            }
            prevDayNum = dnum;
            dateText = `${trackMonth}/${dnum}`;
            const d = dayjs(`${trackYear}-${String(trackMonth).padStart(2, '0')}-${String(dnum).padStart(2, '0')}`);
            weekdayText = toWeekday(d);
          } else {
            // 无法识别日期，仅保留原文
            dateText = datePart;
            weekdayText = weekdayPart;
          }
        } else {
          const mmddMatch = rawBottom.match(/^(\d{1,2})\/(\d{1,2})$/);
          const dayMatch = rawBottom.match(/\b(\d{1,2})\b/);
          if (mmddMatch) {
            // 明确 MM/DD —— 更新追踪月份
            const m = parseInt(mmddMatch[1], 10);
            const dnum = parseInt(mmddMatch[2], 10);
            trackMonth = m;
            prevDayNum = dnum;
            dateText = `${m}/${dnum}`;
            const d = dayjs(`${trackYear}-${String(m).padStart(2, '0')}-${String(dnum).padStart(2, '0')}`);
            weekdayText = toWeekday(d);
          } else if (dayMatch) {
            // 只有日 —— 用追踪月份并检测跨月
            const dnum = parseInt(dayMatch[1], 10);
            if (prevDayNum !== null && dnum < prevDayNum) {
              trackMonth += 1;
              if (trackMonth > 12) { trackMonth = 1; trackYear += 1; }
            }
            prevDayNum = dnum;
            dateText = `${trackMonth}/${dnum}`;
            const d = dayjs(`${trackYear}-${String(trackMonth).padStart(2, '0')}-${String(dnum).padStart(2, '0')}`);
            weekdayText = toWeekday(d);
          } else {
            // 无法识别则保留原文为第一行，并补一个中文星期（以当前日期）
            dateText = rawBottom;
            weekdayText = toWeekday(dayjs());
          }
        }

        // 新增：若为周末（六/日），在该列底部文本所在列下方插入一个背景矩形，作为特殊底色
        const bx = parseFloat(bt.getAttribute('x') || '0');
        // 读取 SVG 文本的锚点：gantt-task-react 通过 CSS 设为 text-anchor: middle，这里用 computedStyle 读取；兜底 middle
        const cs = window.getComputedStyle(bt);
        const anchor = (cs && (cs.getPropertyValue && cs.getPropertyValue('text-anchor'))) || bt.getAttribute('text-anchor') || 'middle';
        let rectX = bx;
        if (anchor.trim() === 'middle') rectX = bx - columnWidthPx / 2;
        else if (anchor.trim() === 'end') rectX = bx - columnWidthPx;
        const isWeekend = weekdayText === '六' || weekdayText === '日';
        if (isWeekend) {
          const fillColor = weekdayText === '日' ? '#ffecec' : '#fff7e6'; // 周日偏红、周六偏橙
          // 头部矩形：按列插入
          const existingWeekendRect = calendarGroup.querySelector(`rect[data-weekend-bg="1"][data-col-x="${bx}"]`);
          if (!existingWeekendRect) {
            const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            rect.setAttribute('x', String(rectX));
            rect.setAttribute('y', String(headerY));
            rect.setAttribute('width', String(columnWidthPx));
            rect.setAttribute('height', String(headerHeight));
            rect.setAttribute('fill', fillColor);
            rect.setAttribute('opacity', '0.35');
            rect.setAttribute('data-weekend-bg', '1');
            rect.setAttribute('data-col-x', String(bx));
            // 插入到文本之前，确保矩形在文本下方但覆盖头部底层矩形
            calendarGroup.insertBefore(rect, bt);
          }

          // 表格主体整列矩形：与头部独立判断，避免因已存在头部矩形而跳过
          // 注意：gantt-task-react 将表头与主体分别渲染在两个兄弟 SVG 中，因此不能用 headerSvg 查询 gridBody
          const container = headerSvg?.parentElement; // 垂直容器 .ganttVerticalContainer
          const ganttSvg = container?.querySelector('div svg')
            || headerSvg?.nextElementSibling?.querySelector?.('svg');
          const gridBody = ganttSvg?.querySelector('g.gridBody');
          if (gridBody) {
            // 计算 gridBody 的总高度
            const rowsGroup = gridBody.querySelector('g.rows');
            let gridHeight = 0;
            if (rowsGroup) {
              const rowRects = rowsGroup.querySelectorAll('rect');
              if (rowRects.length) {
                const last = rowRects[rowRects.length - 1];
                const ly = parseFloat(last.getAttribute('y') || '0');
                const lh = parseFloat(last.getAttribute('height') || '0');
                gridHeight = ly + lh;
              }
            }
            // 兜底：当 rows 尚未渲染或高度为 0 时，使用主体 SVG 的高度或 gridBody 的边界高度
            if (!gridHeight) {
              gridHeight = parseFloat(ganttSvg?.getAttribute('height') || '0');
              try {
                if (!gridHeight && typeof gridBody.getBBox === 'function') {
                  gridHeight = gridBody.getBBox().height || 0;
                }
              } catch (e) {
                // getBBox 在某些环境中可能不可用或抛错，忽略
              }
            }

            const existingWeekendCol = gridBody.querySelector(`rect[data-weekend-col="1"][data-col-x="${bx}"]`);
            if (!existingWeekendCol && gridHeight > 0) {
              const rect2 = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
              rect2.setAttribute('x', String(rectX));
              rect2.setAttribute('y', '0');
              rect2.setAttribute('width', String(columnWidthPx));
              rect2.setAttribute('height', String(gridHeight));
              rect2.setAttribute('fill', fillColor);
              rect2.setAttribute('opacity', '0.35');
              rect2.setAttribute('data-weekend-col', '1');
              rect2.setAttribute('data-col-x', String(bx));
              // 保证网格行线可见：插入到 rowLines 分组之前
              const rowLinesGroup = gridBody.querySelector('g.rowLines');
              if (rowLinesGroup) gridBody.insertBefore(rect2, rowLinesGroup);
              else {
                const ticksGroup = gridBody.querySelector('g.ticks');
                if (ticksGroup) gridBody.insertBefore(rect2, ticksGroup); else gridBody.appendChild(rect2);
              }
            }
          }
        }

        // 将底部文本改造成两行（MM/DD 与 周X），不再修改顶部文本，确保每列都有完整“日期 + 星期”
        while (bt.firstChild) bt.removeChild(bt.firstChild);
        const x = bt.getAttribute('x') || '0';
        // 使用绝对 y 坐标，避免相对 dy 导致第二行被裁剪
        const yDate = String(Math.round(headerHeight * 0.60));
        const yWeek = String(Math.round(headerHeight * 0.85));
        const tspan1 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
        tspan1.setAttribute('x', x);
        tspan1.setAttribute('y', yDate);
        tspan1.textContent = dateText;
        const tspan2 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
        tspan2.setAttribute('x', x);
        tspan2.setAttribute('y', yWeek);
        tspan2.textContent = weekdayText;
        bt.appendChild(tspan1);
        bt.appendChild(tspan2);
        // 标记已处理，防止重复注入
        bt.setAttribute('data-split', '1');
      });
    };

    const timer = setTimeout(transformHeader, 160);
    return () => clearTimeout(timer);
  }, [viewMode, project?.tasks]);

  /**
   * 灏嗗悗绔换鍔℃暟缁勮浆鎹负 gantt-task-react 缁勪欢鎵€闇€鐨勬暟鎹粨鏋?
   * 淇锛氱‘淇?start/end 濮嬬粓涓烘湁鏁堢殑 Date锛岄伩鍏嶅嚭鐜?getTime 璇诲彇 undefined 鐨勬姤閿?
   * - 鑻ュ悗绔己澶?闈炴硶鏃ユ湡锛屽垯鎸夆€滃綋鍓嶅伐浣滄棩 + 棰勪及宸ユ椂(姣忓ぉ8灏忔椂)鈥濆洖閫€璁＄畻
   * - 淇锛氫互棰勪及宸ユ椂鎺ㄥ鏈熸湜缁撴潫鏃ユ湡锛屽鏋滃悗绔粨鏉熸椂闂翠笉瓒充互瑕嗙洊宸ユ椂锛屾彁鍗囦负鎸夊伐鏃惰绠楃殑缁撴潫鏃ユ湡锛岄伩鍏嶆潯褰粎鍗犱竴澶?
   */
  const convertTasksToGanttData = (tasks = []) => {
    // 宸ュ叿锛氬垽鏂?Date 鏄惁鏈夋晥
    const isValidDate = (d) => d instanceof Date && !isNaN(d.getTime());

    return (tasks || [])
      .filter(Boolean) // 杩囨护鎺夊彲鑳藉嚭鐜扮殑 null/undefined 椤?
      .map((t) => {
        // 1) 浼樺厛浣跨敤鍚庣杩斿洖鐨勫紑濮?缁撴潫鏃堕棿
        let start = t.startDate ? new Date(t.startDate) : undefined;
        let end = t.dueDate ? new Date(t.dueDate) : undefined;

        // 2) 瑙勮寖寮€濮嬫棩鏈燂細鑻ユ棤鏁堝垯鍥為€€鍒板綋鍓嶅伐浣滄棩
        const hours = Number(t.estimatedHours || 8);
        const baseStartWorkday = isValidDate(start) ? dayjs(start) : getCurrentWorkday(); // dayjs 瀵硅薄
        if (!isValidDate(start)) start = baseStartWorkday.toDate();

        // 3) 鍩轰簬宸ユ椂璁＄畻鈥滄湡鏈涚粨鏉熸棩鏈熲€濓紙姣忓ぉ8灏忔椂銆佽烦杩囧懆鏈級
        const expectedEndByHours = calculateEndDateByHours(baseStartWorkday, hours); // dayjs 瀵硅薄

        // 4) 缁撴潫鏃ユ湡淇绛栫暐锛?
        // - 鑻?end 缂哄け/鏃犳晥 => 浣跨敤鎸夊伐鏃舵帹瀵肩殑 expectedEndByHours
        // - 鑻?end 鏃╀簬 start => 浣跨敤 expectedEndByHours锛堥伩鍏嶅嚭鐜拌礋璺ㄥ害瀵艰嚧琚帇鎴愪竴澶╋級
        // - 鑻?end 鏃╀簬 expectedEndByHours => 鎻愬崌涓?expectedEndByHours锛堢‘淇濊瑙夎法搴︿笌宸ユ椂涓€鑷达級
        if (!isValidDate(end)) {
          end = expectedEndByHours.toDate();
        } else {
          const endJs = dayjs(end);
          if (endJs.isBefore(baseStartWorkday) || endJs.isBefore(expectedEndByHours)) {
            end = expectedEndByHours.toDate();
          }
        }

        // 5) 缁熶竴灏嗙粨鏉熸椂闂村畾浣嶅埌褰撳ぉ缁撴潫鏃跺埢锛屾彁鍗囧澶╀换鍔＄殑鍙鍖栧崰鐢紙閬垮厤鍙樉绀哄埌褰撳ぉ闆剁偣锛?
        end = dayjs(end).endOf('day').toDate();

        const progress = typeof t.progress === 'number' ? t.progress : (t.status === 'done' ? 100 : 0);
        return {
          id: String(t.id),
          name: t.title || `浠诲姟${t.id}`,
          start,
          end,
          progress: Math.max(0, Math.min(100, progress)),
          type: 'task'
        };
      });
  };

  /**
   * 鐢樼壒鍥句换鍔℃棩鏈熷彉鏇村洖璋冿細灏嗘嫋鎷借皟鏁村悗鐨勫紑濮嬪拰缁撴潫鏃堕棿鍚屾鍒板悗鍙?
   */
  const handleGanttDateChange = (updatedTask) => {
    const original = project?.tasks?.find((x) => x.id.toString() === updatedTask.id);
    if (!original) return;

    // 璁＄畻鎷栨嫿鍚庤法搴﹀搴旂殑宸ユ椂锛堟寜宸ヤ綔鏃ヨ锛屾瘡涓伐浣滄棩8灏忔椂锛?
    // 涓枃娉ㄩ噴锛氬綋鐢ㄦ埛閫氳繃璋冩暣鏉″舰瀹藉害鏀瑰彉浠诲姟璺ㄥ害鏃讹紝鎴戜滑灏嗘柊鐨勫紑濮?缁撴潫鏃ユ湡鎹㈢畻涓哄寘鍚鐐圭殑宸ヤ綔鏃ュぉ鏁帮紝鍐嶄箻浠?寰楀埌鏂扮殑棰勪及宸ユ椂銆?
    let estimatedHoursFromSpan = undefined;
    try {
      const startJs = dayjs(updatedTask.start);
      const endJs = dayjs(updatedTask.end);
      if (startJs.isValid() && endJs.isValid()) {
        const workdays = countWorkdaysInclusive(startJs, endJs);
        if (workdays > 0) {
          estimatedHoursFromSpan = workdays * 8;
        }
      }
    } catch (e) {
      // 闈欓粯澶辫触锛氳嫢璁＄畻澶辫触锛屼笉闃绘柇鏃ユ湡鏇存柊
      estimatedHoursFromSpan = undefined;
    }

    const updateData = {
      startDate: updatedTask.start ? new Date(updatedTask.start).toISOString() : null,
      dueDate: updatedTask.end ? new Date(updatedTask.end).toISOString() : null,
      // 浠呭綋鎴愬姛璁＄畻鍑烘柊宸ユ椂鏃舵墠涓€骞舵彁浜?
      ...(typeof estimatedHoursFromSpan === 'number' ? { estimatedHours: estimatedHoursFromSpan } : {}),
    };

    updateTaskMutation.mutate({
      taskId: original.id,
      updateData,
    });
  };

  /**
   * 鐢樼壒鍥句换鍔¤繘搴﹀彉鏇村洖璋冿細灏嗚皟鏁村悗鐨勮繘搴︼紙0-100锛夊悓姝ュ埌鍚庣
   */
  const handleGanttProgressChange = (updatedTask) => {
    const original = project?.tasks?.find((x) => x.id.toString() === updatedTask.id);
    if (!original) return;
    const progress = Math.max(0, Math.min(100, Math.round(updatedTask.progress || 0)));
    updateTaskMutation.mutate({
      taskId: original.id,
      updateData: { progress },
    });
  };

  /**
   * 鎵撳紑浠诲姟缂栬緫寮圭獥骞跺～鍏呰〃鍗?
   */
  const handleEditTask = (originalTask) => {
    setEditingTask(originalTask || null);
    setIsTaskModalVisible(true);
    if (originalTask) {
      taskForm.setFieldsValue({
        title: originalTask.title || '',
        description: originalTask.description || '',
        assignedTo: originalTask.assignedTo ?? undefined,
        priority: originalTask.priority || 'medium',
        // 绉婚櫎瀵瑰紑濮?鎴鏃堕棿鐨勮〃鍗曡祴鍊?
        estimatedHours: originalTask.estimatedHours ?? undefined,
        tags: Array.isArray(originalTask.tags) ? originalTask.tags.join(',') : (originalTask.tags || ''),
      });
    } else {
      taskForm.resetFields();
    }
  };

  /**
   * 浠诲姟寮圭獥鈥滅‘瀹氣€濆鐞嗭細鏍￠獙骞舵彁浜ゅ垱寤?鏇存柊
   * 闇€姹備慨姝ｏ細
   * - 鍒涘缓锛氭寜鈥滈浼板伐鏃?灏忔椂)鈥濊绠楀紑濮?缁撴潫鏃ユ湡锛堟瘡澶?灏忔椂锛?
   * - 缂栬緫锛氭湭淇敼宸ユ椂鏃朵繚鐣欏師 estimatedHours锛屼笖涓嶉噸绠楀紑濮?缁撴潫鏃ユ湡
   */
  const handleTaskModalOk = async () => {
    try {
      const values = await taskForm.validateFields();
      const isEditing = !!editingTask;

      // 璁＄畻宸ユ椂锛氱紪杈戞椂浼樺厛淇濈暀鍘熷€硷紱鍒涘缓鏃堕粯璁?灏忔椂
      let hours = Number(values.estimatedHours);
      if (!Number.isFinite(hours) || hours <= 0) {
        const prev = Number(editingTask?.estimatedHours);
        hours = isEditing && Number.isFinite(prev) && prev > 0 ? prev : 8;
      }

      // 鏍规嵁鍦烘櫙鏋勯€犳彁浜よ礋杞?
      let payload;

      if (isEditing) {
        // 缂栬緫锛氫粎鏇存柊琛ㄥ崟瀛楁涓庡伐鏃讹紝涓嶉噸绠楀紑濮?缁撴潫鏃ユ湡
        payload = {
          title: values.title,
          description: values.description || '',
          assignedTo: values.assignedTo ?? null,
          priority: values.priority,
          estimatedHours: hours,
          tags: typeof values.tags === 'string' ? values.tags : '',
        };
      } else {
        // 鍒涘缓锛氭寜姣忓ぉ8灏忔椂璁＄畻寮€濮?缁撴潫鏃ユ湡
        const { isWorkday, getNextWorkday, calculateEndDateByHours, getCurrentWorkday } = await import('../../utils/workdayUtils');
        let startWorkday = getCurrentWorkday();
        startWorkday = isWorkday(startWorkday) ? startWorkday : getNextWorkday(startWorkday);
        const endWorkday = calculateEndDateByHours(startWorkday, hours);

        payload = {
          title: values.title,
          description: values.description || '',
          assignedTo: values.assignedTo ?? null,
          priority: values.priority,
          startDate: startWorkday.toDate().toISOString(),
          dueDate: endWorkday.toDate().toISOString(),
          estimatedHours: hours,
          tags: typeof values.tags === 'string' ? values.tags : '',
        };
      }

      taskMutation.mutate(payload);
    } catch (e) {
      // 鏍￠獙澶辫触鏃犻渶澶勭悊
    }
  };

  /**
   * 閫夋嫨妯℃澘锛氭牴鎹ā鏉挎壒閲忓垱寤轰换鍔★紝鍖呭惈鍓嶇疆浠诲姟鏃堕棿璁＄畻鍜屽伐浣滄棩璺宠繃閫昏緫
   */
  const handleTemplateSelect = async (template) => {
    setIsTemplateModalVisible(false);
    
    if (!template?.taskList || template.taskList.length === 0) {
      message.warning('该模板没有任务清单');
      return;
    }

    try {
      // 瀵煎叆宸ヤ綔鏃ヨ绠楀伐鍏凤紙绉婚櫎绗簩涓伐浣滄棩閫昏緫锛屾敼涓轰娇鐢ㄢ€滀笅涓€涓伐浣滄棩鈥濓紝閬垮厤涓庡墠缃换鍔＄浉闅斾竴澶╋級
      const { isWorkday, getNextWorkday, calculateEndDateByHours } = await import('../../utils/workdayUtils');
      
      const tasksToCreate = [];
      const taskEndDates = {}; // 瀛樺偍姣忎釜浠诲姟鐨勭粨鏉熸棩鏈燂紝鐢ㄤ簬璁＄畻鍓嶇疆浠诲姟
      
      // 璁＄畻鐢ㄦ埛閫夋嫨鐨勮捣濮嬪伐浣滄棩
      const userBase = templateStartDate || dayjs();
      const baseWorkday = isWorkday(userBase) ? userBase : getNextWorkday(userBase);
      
      // 閬嶅巻妯℃澘浠诲姟鍒楄〃锛岃绠楁瘡涓换鍔＄殑鏃堕棿
      template.taskList.forEach((templateTask, index) => {
        let startDate;
        
        // 鍒ゆ柇鏄惁鏈夊墠缃换鍔?
        if (templateTask.preTaskIndex && templateTask.preTaskIndex > 0) {
          // 鏈夊墠缃换鍔★細寮€濮嬫椂闂翠负鍓嶇疆浠诲姟瀹屾垚鍚庣殑涓嬩竴涓伐浣滄棩锛堢浉閭伙紝鏃犻澶栫┖涓€澶╋級
          const preTaskIndex = templateTask.preTaskIndex - 1; // 杞崲涓烘暟缁勭储寮?
          if (taskEndDates[preTaskIndex]) {
            startDate = getNextWorkday(taskEndDates[preTaskIndex]);
          } else {
            // 濡傛灉鍓嶇疆浠诲姟涓嶅瓨鍦紝浣跨敤鐢ㄦ埛閫夋嫨鐨勮捣濮嬪伐浣滄棩
            startDate = baseWorkday;
          }
        } else {
          // 鏃犲墠缃换鍔★細寮€濮嬫椂闂翠负鐢ㄦ埛閫夋嫨鐨勮捣濮嬪伐浣滄棩
          startDate = baseWorkday;
        }
        
        // 鏍规嵁宸ユ椂璁＄畻缁撴潫鏃ユ湡
        const endDate = calculateEndDateByHours(startDate, templateTask.estimatedHours || 8);
        
        // 瀛樺偍褰撳墠浠诲姟鐨勭粨鏉熸棩鏈燂紝渚涘悗缁换鍔′娇鐢?
        taskEndDates[index] = endDate;
        
        // 鏋勫缓浠诲姟鏁版嵁
        const taskData = {
          title: templateTask.title,
          description: templateTask.description || '',
          priority: templateTask.priority || 'medium',
          estimatedHours: Number(templateTask.estimatedHours ?? 8),
          startDate: startDate.toDate().toISOString(),
          dueDate: endDate.toDate().toISOString(),
          tags: '',
          projectId: parseInt(id, 10) // 纭繚projectId涓烘暣鏁?
        };
        // 濡傛ā鏉夸腑鍖呭惈榛樿鎵ц浜轰笖涓烘湁鏁堟暣鏁帮紝鍒欎紶閫抋ssignedTo
        if (templateTask.assignedTo) {
          taskData.assignedTo = parseInt(templateTask.assignedTo, 10);
        }
        
        tasksToCreate.push(taskData);
      });
      
      // 批量创建任务
      message.loading('正在创建任务...', 0);
      
      for (const taskData of tasksToCreate) {
        await axios.post('/tasks', taskData);
      }
      
      message.destroy();
      message.success(`成功创建 ${tasksToCreate.length} 个任务`);
      
      // 刷新项目数据
      queryClient.invalidateQueries(['project', id]);
      
    } catch (error) {
      message.destroy();
      message.error(error.response?.data?.message || '创建任务失败');
    }
  };

  // 涓讳綋娓叉煋锛氳繑鍥為〉闈㈠唴瀹癸紙澶栧眰浣跨敤 div 鍖呰９锛?
  return (
    <div style={{ padding: '24px' }}>
      {/* 杩斿洖鎸夐挳 */}
      <Button 
        icon={<ArrowLeftOutlined />} 
        onClick={() => navigate('/projects')}
        style={{ marginBottom: '16px' }}
      >
        返回项目列表
      </Button>

      {isLoading ? (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" />
        </div>
      ) : project ? (
        <>
          {/* 椤圭洰鍩烘湰淇℃伅 */}
          <Card style={{ marginBottom: '24px' }}>
            <Row gutter={24}>
                <Col span={16}>
                  {/* 涓枃璇存槑锛氱Щ闄も€滈」鐩被鍨嬧€濈殑鏂囧瓧鏍囩锛屽皢绫诲瀷 Tag 鏀惧埌椤圭洰鍚嶇О宸︿晶锛屽苟涓庡悕绉扮揣瀵嗙浉閭?*/}
                  <Descriptions
                    title={
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Tag color="blue" style={{ marginRight: 8 }}>{getProjectTypeText(project.type)}</Tag>
                        <Button type="link" onClick={() => setIsLeaderProjectsModalVisible(true)} style={{ padding: 0 }}>{project.name}</Button>
                      </div>
                    }
                    column={2}
                  >
                    {/* 宸叉寜闇€姹傜Щ闄わ細椤圭洰绫诲瀷锛堟敼涓烘爣棰樺乏渚ag灞曠ず锛?/}
                    {/* 宸叉寜闇€姹傜Щ闄わ細椤圭洰鐘舵€?*/}
                    <Descriptions.Item label="设计负责人">
                      {project.designLeader?.realName || '未指定'}
                    </Descriptions.Item>
                    {/* 宸叉寜闇€姹傜Щ闄わ細椤圭洰缁忕悊 */}
                    <Descriptions.Item label="截止时间">
                      {project.expectedDeliveryDate ? dayjs(project.expectedDeliveryDate).format('YYYY-MM-DD') : '未设置'}
                    </Descriptions.Item>
                    {/* 椤圭洰棰勭畻 */}
                    <Descriptions.Item label="项目预算" span={2}>
                      ￥{project.budget?.toLocaleString() || 0}
                    </Descriptions.Item>
                  </Descriptions>
              {/* 负责人项目列表弹窗：滚动查看并可点击跳转 */}
              <Modal
                title="该设计负责人负责的所有项目"
                open={isLeaderProjectsModalVisible}
                onCancel={() => setIsLeaderProjectsModalVisible(false)}
                footer={null}
                bodyStyle={{ maxHeight: '60vh', overflowY: 'auto', paddingTop: 8, paddingBottom: 8 }}
              >
                {isLoadingLeaderProjects ? (
                  <div style={{ textAlign: 'center', padding: 24 }}>
                    <Spin />
                  </div>
                ) : (
                  <List
                    size="small"
                    split={false}
                    dataSource={(leaderProjectsData?.projects || leaderProjectsData || []).filter(p => !!p?.id)}
                    renderItem={(p) => (
                      <List.Item style={{ padding: '4px 0' }}>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: 8, justifyContent: 'space-between' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, flex: 1 }}>
                            <Button
                              type="link"
                              onClick={() => {
                                setIsLeaderProjectsModalVisible(false);
                                navigate(`/projects/${p.id}`);
                              }}
                              style={{ padding: 0, textAlign: 'left', minWidth: 0, maxWidth: '65%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
                            >
                              {p.name}
                            </Button>
                            <Tag>{getProjectTypeText(p.type)}</Tag>
                          </div>
                          <Progress percent={p.progress} size="small" status={p.progress === 100 ? 'success' : 'active'} style={{ width: 140, marginLeft: 8 }} />
                        </div>
                      </List.Item>
                    )}
                  />
                )}
              </Modal>
              </Col>
              <Col span={8}>
                <Row gutter={16}>
                  <Col span={12}>
                    <Statistic
                      title="任务总数"
                      value={project.tasks?.length || 0}
                      prefix={<ProjectOutlined />}
                    />
                  </Col>
                  <Col span={12}>
                    <Statistic
                      title="完成率"
                      value={project.progress || 0}
                      suffix="%"
                      valueStyle={{ color: project.progress >= 80 ? '#3f8600' : project.progress >= 50 ? '#faad14' : '#cf1322' }}
                    />
                  </Col>
                </Row>
                <Progress 
                  percent={project.progress || 0} 
                  style={{ marginTop: '16px' }}
                  status={project.progress === 100 ? 'success' : 'active'}
                />
              </Col>
            </Row>
          </Card>

          {/* 鎿嶄綔鏍?*/}
          <Card style={{ marginBottom: '24px' }}>
            <Row justify="space-between" align="middle">
              <Col>
                <Space>
                  <Button
                    type={viewMode === 'gantt' ? 'primary' : 'default'}
                    icon={<BarChartOutlined />}
                    onClick={() => setViewMode('gantt')}
                  >
                    甘特图
                  </Button>
                  <Button
                    type={viewMode === 'list' ? 'primary' : 'default'}
                    icon={<UnorderedListOutlined />}
                    onClick={() => setViewMode('list')}
                  >
                    列表视图
                  </Button>
                </Space>
              </Col>
              <Col>
                <Space>
                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={handleBatchDeleteSelected}
                    disabled={selectedTaskIds.length === 0 || isBatchDeleting}
                    loading={isBatchDeleting}
                  >
                    删除选中任务
                  </Button>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => handleEditTask(null)}
                  >
                    新建任务
                  </Button>
                  <Button
                    icon={<FileTextOutlined />}
                    onClick={() => setIsTemplateModalVisible(true)}
                  >
                    选择模板
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>

          {/* 浠诲姟鍐呭鍖哄煙 */}
          <Card>
            {viewMode === 'gantt' ? (
              // 鐢樼壒鍥捐鍥?
              project?.tasks && project.tasks.length > 0 ? (
                <Gantt
                tasks={convertTasksToGanttData(project?.tasks)}
                viewMode={ViewMode.Day}
                locale="zh-CN"
                listCellWidth="280px"
                columnWidth={40}
                rowHeight={50}
                barCornerRadius={3}
                handleWidth={8}
                fontFamily="Arial, sans-serif"
                fontSize="14px"
                barFill={60}
                barProgressColor="#a3a3ff"
                barProgressSelectedColor="#8282f6"
                barBackgroundColor="#b8c2cc"
                barBackgroundSelectedColor="#aeb8c2"
                projectProgressColor="#7db46c"
                projectProgressSelectedColor="#59a13f"
                projectBackgroundColor="#fac465"
                projectBackgroundSelectedColor="#f7bb53"
                milestoneBackgroundColor="#f1c453"
                milestoneBackgroundSelectedColor="#f29e4c"
                rtl={false}
                headerHeight={60}
                TaskListHeader={({ headerHeight }) => (
                  <div style={{
                    height: headerHeight,
                    backgroundColor: '#fafafa',
                    border: '1px solid #d9d9d9',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: 12,
                    fontWeight: 600
                  }}>
                    <div
                      style={{ width: 36, paddingLeft: 8, cursor: 'pointer', color: '#1890ff' }}
                      onClick={toggleSelectAllTasks}
                      title="点击全选/取消全选"
                     >选择</div>
                    <div style={{ flex: 1, padding: '0 8px' }}>任务名称</div>
                    <div style={{ width: 120, padding: '0 8px', borderLeft: '1px solid #d9d9d9' }}>执行人</div>
                  </div>
                )}
                TaskListTable={(args) => {
                  // 涓枃鍑芥暟绾ф敞閲婏細鑷畾涔夌敇鐗瑰浘宸︿晶浠诲姟娓呭崟琛ㄦ牸锛屾敮鎸佸嬀閫変换鍔★紙鎵归噺鍒犻櫎锛変笌鏄剧ず/缂栬緫鈥滄墽琛屼汉鈥濆垪
                  const { rowHeight, rowWidth, tasks, selectedTaskId, setSelectedTask } = args;
                  return (
                    <div style={{ width: rowWidth }}>
                      {tasks.map((t, index) => {
                        const originalTask = project?.tasks?.find(x => x.id.toString() === t.id);
                        const assignee = usersArray.find(u => u.id === originalTask?.assignedTo);
                        const canEdit = ['admin','manager','pm','designer'].includes(user?.role);
                        const isEditing = editingAssigneeTaskId === originalTask?.id;
                        const currentValue = originalTask?.assignedTo ?? undefined;
                        const checked = originalTask ? selectedTaskIds.includes(originalTask.id) : false;
                        return (
                          <div
                            key={t.id}
                            style={{
                              height: rowHeight,
                              display: 'flex',
                              alignItems: 'center',
                              backgroundColor: selectedTaskId === t.id ? '#e6f7ff' : index % 2 === 0 ? '#fafafa' : '#ffffff'
                            }}
                            onClick={() => setSelectedTask?.(t.id)}
                          >
                            <div style={{ width: 36, paddingLeft: 8 }}>
                              <Checkbox
                                checked={checked}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  if (originalTask) toggleSelectTask(originalTask.id);
                                }}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </div>
                            <div style={{ flex: 1, padding: '0 8px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{t.name}</div>
                            <div style={{ width: 120, padding: '0 8px', borderLeft: '1px solid #f0f0f0' }}>
                              {isEditing ? (
                                <Select
                                  size="small"
                                  allowClear
                                  showSearch
                                  placeholder="选择执行人"
                                  optionFilterProp="children"
                                  style={{ width: '100%' }}
                                  defaultValue={currentValue}
                                  onChange={(val) => originalTask && handleAssigneeChange(originalTask.id, val || null)}
                                  onBlur={handleAssigneeBlur}
                                >
                                  {Object.keys(groupedUsersByPosition).sort().map(pos => (
                                    <Select.OptGroup key={pos} label={pos + '（' + ((groupedUsersByPosition[pos] || []).length) + '人）'}>
                                      {groupedUsersByPosition[pos].map(u => (
                                        <Option key={u.id} value={u.id}>
                                          {u.realName + '（' + (u.position || '未设置职位') + '）'}
                                        </Option>
                                      ))}
                                    </Select.OptGroup>
                                  ))}
                                </Select>
                              ) : (
                                <span
                                  style={{ cursor: canEdit ? 'pointer' : 'default', color: canEdit ? '#1890ff' : 'inherit' }}
                                  onClick={() => canEdit && originalTask && handleAssigneeCellClick(originalTask)}
                                  title={canEdit ? '点击修改执行人' : undefined}
                                >
                                  {assignee?.realName || '未指定'}
                                 </span>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                }}

                onDateChange={handleGanttDateChange}
                onProgressChange={handleGanttProgressChange}
                onDoubleClick={(task) => {
                  console.log('鍙屽嚮浠诲姟:', task);
                  const originalTask = project?.tasks?.find(t => t.id.toString() === task.id);
                  if (originalTask) {
                    handleEditTask(originalTask);
                  }
                }}
                />
              ) : (
                <div style={{ 
                  textAlign: 'center', 
                  padding: '50px', 
                  color: '#999',
                  fontSize: '16px'
                }}>
                  暂无任务数据，点击“新建任务”开始添加任务
                </div>
              )
            ) : (
              // 鍒楄〃瑙嗗浘
              <Table
                dataSource={project?.tasks || []}
                rowKey="id"
                rowSelection={{
                  selectedRowKeys: selectedTaskIds,
                  onChange: (keys) => setSelectedTaskIds(keys),
                }}
                columns={[
                  {
                    title: '任务标题',
                    dataIndex: 'title',
                    key: 'title',
                    render: (text, record) => (
                      <Button 
                        type="link" 
                        onClick={() => handleEditTask(record)}
                        style={{ padding: 0, height: 'auto' }}
                      >
                        {text}
                      </Button>
                    )
                  },
                  {
                    title: '执行人',
                    dataIndex: 'assignedTo',
                    key: 'assignedTo',
                    render: (assignedTo, record) => {
                      const assignee = usersArray.find(u => u.id === assignedTo);
                      const canEdit = ['admin','manager','pm','designer'].includes(user?.role);
                      const isEditing = editingAssigneeTaskId === record.id;
                      
                      if (canEdit && isEditing) {
                        return (
                          <Select
                            value={assignedTo}
                            style={{ width: 120 }}
                            placeholder="选择执行人"
                            allowClear
                            showSearch
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={(value) => handleAssigneeChange(record.id, value)}
                            onBlur={() => setEditingAssigneeTaskId(null)}
                            autoFocus
                          >
                            {usersArray.map(user => (
                              <Option key={user.id} value={user.id}>
                                {user.realName}
                              </Option>
                            ))}
                          </Select>
                        );
                      }
                      
                      return (
                        <span
                          style={{ 
                            cursor: canEdit ? 'pointer' : 'default',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            border: canEdit ? '1px solid transparent' : 'none'
                          }}
                          onMouseEnter={(e) => {
                            if (canEdit) {
                              e.target.style.backgroundColor = '#f5f5f5';
                              e.target.style.border = '1px solid #d9d9d9';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (canEdit) {
                              e.target.style.backgroundColor = 'transparent';
                              e.target.style.border = '1px solid transparent';
                            }
                          }}
                          onClick={() => {
                            if (canEdit) {
                              setEditingAssigneeTaskId(record.id);
                            }
                          }}
                        >
                          {assignee?.realName || '未指定'}
                        </span>
                      );
                    }
                  },
                  {
                    title: '优先级',
                    dataIndex: 'priority',
                    key: 'priority',
                    render: (priority) => {
                      const colors = { high: 'red', medium: 'orange', low: 'green' };
                      const texts = { high: '高', medium: '中', low: '低' };
                      return <Tag color={colors[priority]}>{texts[priority]}</Tag>;
                    }
                  },
                  {
                    title: '状态',
                    dataIndex: 'status',
                    key: 'status',
                    render: (status) => {
                      const colors = { todo: 'default', doing: 'processing', done: 'success' };
                      const texts = { todo: '待办', doing: '进行中', done: '已完成' };
                      return <Tag color={colors[status]}>{texts[status]}</Tag>;
                    }
                  },
                  {
                    title: '开始时间',
                    dataIndex: 'startDate',
                    key: 'startDate',
                    render: (date) => date ? dayjs(date).format('YYYY-MM-DD') : '-'
                  },
                  {
                    title: '截止时间',
                    dataIndex: 'dueDate',
                    key: 'dueDate',
                    render: (date) => date ? dayjs(date).format('YYYY-MM-DD HH:mm') : '-'
                  },
                  {
                    title: '进度',
                    dataIndex: 'progress',
                    key: 'progress',
                    render: (progress) => (
                      <Progress 
                        percent={progress || 0} 
                        size="small"
                        status={progress === 100 ? 'success' : 'active'}
                      />
                    )
                  },
                  {
                    title: '操作',
                    key: 'action',
                    render: (_, record) => {
                      // 妫€鏌ュ垹闄ゆ潈闄愶細鍒涘缓鑰呫€佽璁¤礋璐ｄ汉銆乵anager銆乤dmin
                      const canDelete = record.createdBy === user?.id || 
                                       project?.designLeaderId === user?.id ||
                                       ['manager', 'admin'].includes(user?.role);
                      
                      return (
                        <Space>
                          <Button 
                            type="link" 
                            icon={<EditOutlined />}
                            onClick={() => handleEditTask(record)}
                          >
                            编辑
                          </Button>
                          {canDelete && (
                            <Button 
                              type="link" 
                              icon={<DeleteOutlined />}
                              onClick={() => handleDeleteTask(record)}
                              danger
                            >
                              删除
                            </Button>
                          )}
                        </Space>
                      );
                    }
                  }
                ]}
                pagination={false}
                locale={{ emptyText: '暂无任务数据，点击“新建任务”开始添加任务' }}
              />
            )}
          </Card>
        </>
      ) : (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <div style={{ fontSize: '16px', color: '#999' }}>项目不存在或已被删除</div>
        </div>
      )}

      {/* 浠诲姟鍒涘缓/缂栬緫妯℃€佹 */}
      <Modal
        title={editingTask ? '编辑任务' : '新建任务'}
        open={isTaskModalVisible}
        onOk={handleTaskModalOk}
        onCancel={() => {
          setIsTaskModalVisible(false);
          setEditingTask(null);
          taskForm.resetFields();
        }}
        confirmLoading={taskMutation.isLoading}
        width={600}
      >
        <Form
          form={taskForm}
          layout="vertical"
          initialValues={{
            priority: 'medium'
          }}
        >
          <Form.Item
            name="title"
            label="任务标题"
            rules={[{ required: true, message: '请输入任务标题' }]}
          >
            <AutoComplete
              options={taskTitleOptions}
              placeholder="请输入或选择任务标题"
              filterOption={(inputValue, option) =>
                option.value.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
              }
              allowClear
            />
          </Form.Item>

          <Form.Item
            name="description"
            label="任务描述"
          >
            <TextArea rows={3} placeholder="请输入任务描述" />
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="assignedTo"
                label="执行人"
              >
                <Select placeholder="选择执行人" allowClear>
                  {usersArray.filter(u => ['designer', 'manager', 'pm'].includes(u.role))
                    .map(user => (
                      <Option key={user.id} value={user.id}>
                        {user.realName} - {user.position}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            
            <Col span={12}>
              <Form.Item
                name="priority"
                label="优先级"
                 rules={[{ required: true, message: '请选择优先级' }]}
               >
                 <Select>
                   <Option value="high">高优先级</Option>
                   <Option value="medium">中优先级</Option>
                   <Option value="low">低优先级</Option>
                 </Select>
              </Form.Item>
            </Col>
          </Row>


          <Form.Item
            name="estimatedHours"
            label="预计工时（小时）"
           >
             <InputNumber
               min={0}
               step={0.5}
               style={{ width: '100%' }}
               placeholder="请输入预计工时"
             />
          </Form.Item>

          <Form.Item
             name="tags"
             label="标签"
           >
             <Input placeholder="多个标签用逗号分隔" />
           </Form.Item>
        </Form>
      </Modal>

      {/* 浠诲姟妯℃澘閫夋嫨妯℃€佹 */}
      <Modal
        title="选择任务模板"
        open={isTemplateModalVisible}
        onCancel={() => setIsTemplateModalVisible(false)}
        footer={null}
        width={600}
      >
        {/* 璧峰鏃ユ湡閫夋嫨 */}
        <div style={{ marginBottom: 16 }}>
          <span style={{ marginRight: 8 }}>开始日期：</span>
          <DatePicker
            value={templateStartDate}
            onChange={setTemplateStartDate}
            format="YYYY-MM-DD"
          />
          <div style={{ color: '#999', marginTop: 4 }}>如不设置，模板任务默认从该日期开始，遇到周末将自动顺延至下一个工作日。</div>
        </div>
        <List
          dataSource={templatesData?.templates || []}
          renderItem={(template) => (
            <List.Item
              actions={[
                <Button 
                  type="primary" 
                  onClick={() => handleTemplateSelect(template)}
>
                  选择模板
                </Button>
              ]}
            >
              <List.Item.Meta
                title={template.name}
                description={
                  <div>
                    <div>{template.description}</div>
                    <div style={{ marginTop: '8px', color: '#666' }}>
                      <Tag>{getProjectTypeText(template.projectType)}</Tag>
                      <span style={{ marginLeft: '8px' }}>包含 {template.taskList?.length || 0} 个任务</span>
                       <span style={{ marginLeft: '8px' }}>预计 {template.estimatedDays} 天</span>
                    </div>
                  </div>
                }
              />
            </List.Item>
          )}
          locale={{ emptyText: '暂无可用模板' }}
        />
      </Modal>
    </div>
  );
};

// 鑾峰彇椤圭洰绫诲瀷鏂囨湰
const getProjectTypeText = (type) => {
  const typeMap = {
    bidding: '招标项目',
    application: '申报项目',
    deepening: '深化设计',
    consultation: '咨询项目',
    other: '其他'
  };
  return typeMap[type] || type;
};

export default ProjectDetail;
